import React, {  Suspense, useEffect, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom"
import './App.css';
import './dynamic.css'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GlobalProvider } from "./GlobalProvider";
import { fetchHotelDetails } from "./ServerCall";
import { dispatchEventToParent, setLocalStorageData } from "./utils/commanFunctions";
import Spinner from "./components/spinner/Spinner";
import { Header } from "./components/common/Header";
import UI from "./components/DataWithFilter/UI";
import Trip from "./components/Trip/Trip";
import Description from "./components/Description/Description";
import RouteTracker from "./utils/RouteTracker"


import Store from "./components/Store/Store";
import {Explore} from "./components/Trip/Explore";
import PersonalizedStayUI from "./components/Personalized/PersonalizedStayUI";
import CustomModal from "./components/Modal/CustomModal";
import PersonalizedStayMapPage from "./components/Personalized/PersonalizedStayMapPage";
import SingleRowComponent from "./components/SingleRowComponent";
import DetailNew from "./components/Description/DetailNew";
import PersonalizedStayInit from "./components/Personalized/PersonalizedInitPage";
import SeeAll from "./components/common/SeeAll";
import MyFavorite from "./components/common/MyFav";
import Hotel from "./components/Hotel/Hotel";
import Welcome from "./components/Welcome/Welcome";
import { InnspireChatInitialize, CHAT_SELECTOR } from "./components/Chat";
import configs from "./contentConfig";


// const Store = React.lazy(() => import("./components/Store/Store"));
// const Explore = React.lazy(() => 
//   import("./components/Trip/Explore")
//     .then(module => ({ default: module.Explore || module.default || module }))
// );
// const DetailNew = React.lazy(() => import("./components/Description/DetailNew"));
// const PersonalizedStayInit = React.lazy(() => import("./components/Personalized/PersonalizedInitPage"));
// const SeeAll = React.lazy(() => import("./components/common/SeeAll"));
// const MyFavorite = React.lazy(() => import("./components/common/MyFav"));
// const CustomModal = React.lazy(() => import("./components/Modal/CustomModal"));
// const PersonalizedStayUI = React.lazy(() => import("./components/Personalized/PersonalizedStayUI"));
// const PersonalizedStayMapPage = React.lazy(() => import("./components/Personalized/PersonalizedStayMapPage"));
// const SingleRowComponent = React.lazy(() => import("./components/SingleRowComponent"));
// const Header = React.lazy(() => 
//   import("./components/common/Header")
//     .then(module => ({ default: module.Header || module.default || module }))
// );


const LoadingSpinner = () => (
  <div className="w-full flex justify-center items-center h-[100vh]">
  <Spinner />
</div>
);

const HomePage = process.env.REACT_APP_HOMEPAGE || '/apps/recommender/'
// const showChat = process.env.REACT_APP_BUILD === "beta" ? true : true;

function App(props) {
  const location = useLocation();
  const messageListenerAttached = useRef(null)
  
  const queryString = (() => {
    // if (initialLoad.current && props.url) {
    //   try {
    //     return new URL(props.url).search;
    //   } catch (error) {
    //     console.error("Invalid URL passed to props.url:", error);
    //     return location.search;
    //   }
    // }
    return location.search;
  })();

  const searchParams = new URLSearchParams(queryString);


  useEffect(() => {
    const is_embedded_in_parent = searchParams.get('is_embedded_in_parent')
    if(!is_embedded_in_parent)
      return

    const eventData = {
      type:"INNSPIRE_GET_DATA",
      payload:{
        key: ["trip_planner_data"]
      }
    }
    dispatchEventToParent(eventData)

    const handleMessage = (event={}) => {
  
      const {type = null, payload } = event?.data
      if(!type || !type.includes("INNSPIRE"))
      return
      
      switch (type) {
        case "INNSPIRE_DATA_TO_IFRAME":
          let localData = JSON.parse(payload.trip_planner_data) || {}
          Object.entries(localData).forEach(([key]) => {
            setLocalStorageData(key, JSON.stringify(localData[key]));
          });
          break;
      
        default:
          console.log("this no match for this event", event.data);
          break;
      }
    };

    if (!messageListenerAttached.current) {      
      window.addEventListener('message', handleMessage);
      messageListenerAttached.current = true; 
    }

    return () => {
      window.removeEventListener('message', handleMessage);
      messageListenerAttached.current = false; 
    };
  }, []);

  const RecommenderRoutes = React.memo(() => {
    const path = searchParams.get('path');

    

    if(path?.includes("singleRow") && path.split("-").length>1){
      const [prefix, type] = path.split("-"); 
      return <SingleRowComponent path={path} attachClass={type} />;
    }
    
    const routes = {
      'welcome': <Welcome />,
      'map': <Store />,
      'trip': <Explore />,
      'hotel': <Hotel/>,
      'description': <DetailNew 
        id={searchParams.get('ID')} 
        goBackToParent={searchParams.get('goBackToParent')} 
      />,
      'personalizedStay': <PersonalizedStayInit />,
      'seeAll': <SeeAll path={path} />,
      'myFavorites': <MyFavorite path={path} />,
      'personalizedStayModal': <CustomModal 
        isOpen={true} 
        setIsOpen={() => {}} 
        Content={() => (
          <div className="h-full bg-white ">
                  <Header
                    data={{
                      title: "PERSONALIZED STAY",
                    }}
                    showFilter={false}
                    showSearch={false}
                    showBookMark={false}
                    showBack={false}
                    intialFetch={false}
                  />
            <PersonalizedStayUI />
          </div>
        )}
      />,
      'personalizedStayPage': <PersonalizedStayMapPage path={path} />,
      'singleRow': <SingleRowComponent path={path} />,
     'singleRowLarge':<SingleRowComponent path={path} size={"large"} subLayout={"v3"}/>,
    };

    return routes[path] || routes[configs.initialPage] || <Explore />;
  });
  

    let server = process.env.REACT_APP_SERVER
    let hotelCode = process.env.REACT_APP_HOTEL_CODE
    let  apiKey= process.env.REACT_APP_API_KEY

    if(server)
      localStorage.setItem("server",server)
    if(hotelCode)
    localStorage.setItem("hotel",hotelCode)
    if(apiKey)
    localStorage.setItem("key",apiKey)



  useEffect(()=>{
  const init = async ()=>{
    const fetchedHotelData = await fetchHotelDetails();
  }
  init()
  },[])

  useEffect(() => {
    if (configs?.chat?.placement === "nav") {
      document.body.classList.add("chat-in-nav");
      return () => document.body.classList.remove("chat-in-nav");
    }
  }, []);

  useEffect(() => {
    const title = configs?.brand?.title;
    if (title) document.title = title;
  }, []);

  useEffect(() => {
    const kit = configs?.fonts?.typekitKit;
    if (!kit) return;
    const id = "typekit-kit";
    if (document.getElementById(id)) return;
    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href = `https://use.typekit.net/${kit}.css`;
    document.head.appendChild(link);
  }, []);


  
  return (
    //  <GlobalProvider>
    //   <div className="App">

    //     <Routes>
    //       <Route path="/map" element={<Store />} />
    //       <Route path="/" element={<Test />} />
    //       <Route path="/" element={<Trip />} />
    //       <Route path="/description/:id" element={<Description />} />
    //     </Routes> 
        <GlobalProvider>
        <div className="App">
        <ToastContainer />
        <RouteTracker/>

        <div id={CHAT_SELECTOR} >
        <InnspireChatInitialize/></div>
          <Routes>
            <Route 
              path={HomePage} 
              element={<RecommenderRoutes />} 
            />
          </Routes>
          {/* <RecommenderRoutes /> */}
        </div>
      </GlobalProvider>
      // </div>
    // </GlobalProvider>
  );
}

export default App; 
